import store from '..'
import firebase from 'firebase/app'

export default {
  namespaced: true,
  state () {
    return {
      chatMessage: {},
      keys: [],
      reference: []
    }
  },
  getters: {
    chatMessage (state) {
      return state.chatMessage
    },
    reference (state) {
      return state.reference
    },
    keys (state) {
      return state.keys
    }
  },
  mutations: {
    init (state) {
      state.chatMessage = {}
      state.keys = []
    },
    boot (state, payload) {
      state.chatMessage[payload.key] = payload.data
    },
    add (state, payload) {
      var back = state.chatMessage
      if (back[payload.parentKey]) {
        var array = back[payload.parentKey]
        array.push(payload)
        back[payload.parentKey] = array
      } else {
        back[payload.parentKey] = [payload]
      }
      state.chatMessage = {}
      state.chatMessage = back
    },
    update (state, payload) {
      var back = state.chatMessage
      if (back[payload.parentKey]) {
        var array = back[payload.parentKey]
        var offset = array.findIndex(message => message.key === payload.key)
        if (offset !== -1) {
          array[offset] = payload
          back[payload.parentKey] = array
          state.chatMessage = {}
          state.chatMessage = back
        }
      }
    },
    remove (state, payload) {
      var back = state.chatMessage
      if (back[payload.parentKey]) {
        var array = back[payload.parentKey]
        var offset = array.findIndex(message => message.key === payload.key)
        if (offset !== -1) {
          array.splice(offset, 1)
          back[payload.parentKey] = array
          state.chatMessage = {}
          state.chatMessage = back
        }
      }
    },
    reference (state, payload) {
      state.reference.push(payload)
    },
    keys (state, payload) {
      state.keys.push(payload)
    }
  },
  actions: {
    init ({ commit }) {
      commit('init')
    },
    subscribe ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        var boot = true
        var temp = []
        var keys = store.getters['chatMessage/keys']
        var index = keys.indexOf(payload)
        if (index !== -1) {
          resolve()
          return
        } else {
          commit('keys', payload)
        }
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var dbRef = db.collection('chats').doc(payload).collection('data')
        var reference = dbRef.orderBy('createdAt', 'desc').limit(100).onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            const payload = {
              key: change.doc.id,
              parentKey: change.doc.ref.parent.parent.id,
              chatType: change.doc.data().chatType,
              content: change.doc.data().content,
              from: change.doc.data().from,
              to: change.doc.data().to,
              read: change.doc.data().read,
              type: change.doc.data().type,
              visible: change.doc.data().visible,
              createdAt: change.doc.data().createdAt,
              updatedAt: change.doc.data().updatedAt
            }
            var data = JSON.parse(JSON.stringify(payload))
            if (boot && change.type === 'added') {
              temp.push(data)
            } else if (change.type === 'added') {
              commit('add', data)
            } else if (change.type === 'modified') {
              commit('update', data)
            } else if (change.type === 'removed') {
              commit('remove', data)
            }
          })
          if (boot) {
            boot = false
            temp.sort(function (a, b) {
              if (a.createdAt > b.createdAt) return 1
              if (a.createdAt < b.createdAt) return -1
              return 0
            })
            commit('boot', { key: payload, data: temp })
          }
          resolve()
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        var reference = store.getters['chatMessage/reference']

        for (var ref in reference) {
          if (reference[ref]) {
            reference[ref]()
            commit('init')
          }
        }
        resolve()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ChatMessage.js